import { gsap, SplitText, ScrollTrigger } from '../utils/gsap';

export function animateTitles() {
  const strongs = document.querySelectorAll('h2 strong, h1 strong');

  strongs.forEach((strong) => {
    const split = new SplitText(strong, { type: 'words' });

    gsap.from(split.words, {
      y: 20,
      opacity: 0.2,
      duration: .7,
      stagger: 0.2,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: strong,
        start: 'top 80%',
        opacity: 1
      }
    });
  });
}